import { useLocalStore } from 'shared/helpers/Store';
import { IS_ENTERED_DISPATCHER_PROFILE } from '../notification-stack/data/PasswordBannerStorage';

export function useDispatcherProfileVisitedValue() {
  return useLocalStore(IS_ENTERED_DISPATCHER_PROFILE);
}
